// Pied de page du site public (une div role="contentinfo" : App.css stylise
// la balise <footer> nue).
import React from "react";
import { Link } from "react-router-dom";
import appIcon from "../images/favicon.png";
import BoutonsStores from "./BoutonsStores";

export default function SiteFooter() {
	const annee = new Date().getFullYear();
	return (
		<div className="gs-pied" role="contentinfo">
			<div className="gs-conteneur">
				<div className="gs-pied-grille">
					<div>
						<Link to="/" className="gs-logo">
							<img src={appIcon} alt="" />
							<span>GymNote</span>
						</Link>
						<p className="gs-pied-accroche">
							Le carnet d'entraînement qui te fait progresser, et le dashboard qui simplifie le coaching.
						</p>
					</div>
					<div>
						<div className="gs-pied-titre">Produit</div>
						<div className="gs-pied-liens">
							<a href="/#fonctionnalites">Fonctionnalités</a>
							<a href="/#coachs">Coachs</a>
							<a href="/#tarifs">Tarifs</a>
							<a href="/#faq">FAQ</a>
						</div>
					</div>
					<div>
						<div className="gs-pied-titre">Légal</div>
						<div className="gs-pied-liens">
							<Link to="/terms">CGU</Link>
							<Link to="/privacy">Confidentialité</Link>
							<Link to="/legal-notice">Mentions légales</Link>
							<Link to="/delete-account">Supprimer mon compte</Link>
						</div>
					</div>
					<div>
						<div className="gs-pied-titre">Télécharger</div>
						<BoutonsStores className="gs-pied-stores" />
					</div>
				</div>
				<div className="gs-pied-bas">
					<span>© {annee} GymNote</span>
					<span>Disponible sur iPhone, iPad et Android</span>
				</div>
			</div>
		</div>
	);
}
